import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const loggedIn = sessionStorage.getItem('userLoggedIn') === '1' && sessionStorage.getItem('dashUser');
    setIsLoggedIn(!!loggedIn);
  }, []);

  window.addEventListener('focus', () => {
    const loggedIn = sessionStorage.getItem('userLoggedIn') === '1' && sessionStorage.getItem('dashUser');
    setIsLoggedIn(!!loggedIn);
  });

  const handleLogout = () => {
    sessionStorage.removeItem('userLoggedIn');
    sessionStorage.removeItem('userExams');
    sessionStorage.removeItem('dashUser');
    setIsLoggedIn(false);
    window.location.href = '/';
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    isActive ? 'active' : '';

  return (
    <>
      <nav className="navbar">
        <div className="navbar-inner">
          <Link to="/" className="nav-logo">
            <div className="logo-mark">360</div>
            <span className="logo-text">
              <span className="digi">Digi</span>
              <span className="learning">Learning</span>
            </span>
          </Link>
          <div className="nav-links">
            <NavLink to="/" className={linkClass} end>Home</NavLink>
            <NavLink to="/programs" className={linkClass}>Programs</NavLink>
            <NavLink to="/training" className={linkClass}>Training</NavLink>
            <NavLink to="/request" className={linkClass}>Request Session</NavLink>
            
            {isLoggedIn && (
              <>
                <Link to="/dashboard">Dashboard</Link>
                <button onClick={handleLogout} style={{ background: 'none', border: 'none', cursor: 'pointer', font: 'inherit', color: 'var(--blue)', fontWeight: 600, padding: '8px 16px' }}>Logout</button>
              </>
            )}
            {!isLoggedIn && (
              <NavLink to="/login" className={linkClass}>Login</NavLink>
            )}
            <Link to="/request" className="btn-nav-cta">Get Started</Link>
          </div>
          <button
            className="hamburger"
            aria-label="Menu"
            onClick={() => setOpen(!open)}
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>
      <div className={`mobile-menu${open ? ' open' : ''}`}>
        <NavLink to="/" end onClick={() => setOpen(false)}>Home</NavLink>
        <NavLink to="/programs" onClick={() => setOpen(false)}>Programs</NavLink>
        <NavLink to="/training" onClick={() => setOpen(false)}>Training</NavLink>
        <NavLink to="/request" onClick={() => setOpen(false)}>Request Session</NavLink>
        
        {isLoggedIn ? (
          <>
            <Link to="/dashboard" onClick={() => setOpen(false)}>Dashboard</Link>
            <button onClick={() => { handleLogout(); setOpen(false); }} style={{ background: 'none', border: 'none', cursor: 'pointer', font: 'inherit', color: 'var(--gray-400)' }}>Logout</button>
          </>
        ) : (
          <>
            <NavLink to="/login" onClick={() => setOpen(false)}>Login</NavLink>
          </>
        )}
      </div>
    </>
  );
};

export default Navbar;
